import React from 'react';
import { useDesignTheme } from '../design/DesignThemeContext';
import { SwarmLogoImage } from '../utils/brandingUtils';

export default function PublicWelcomeHeader({
  variant = 'welcome',
  brandingConfig,
  backLink,
  onSubmitReport,
  onStatistics,
  onAuth,
  onBackToMain,
  pageTitle,
}) {
  const { isCorridor, copy } = useDesignTheme();

  const siteName = brandingConfig?.site_name || 'SWARM';
  const strapline =
    variant === 'statistics'
      ? copy.statisticsSubtitle
      : brandingConfig?.strapline || copy.welcomeSubtitle;

  const brandBlock = (
    <div className="flex items-center gap-3 min-w-0">
      <SwarmLogoImage brandingConfig={brandingConfig} className="w-14 h-14" testId="public-logo" />
      <div className="min-w-0">
        <h1
          className={
            isCorridor
              ? 'swarm-public-header__title'
              : 'text-lg lg:text-xl font-bold text-primary-800 mb-0'
          }
          data-testid="public-site-name"
        >
          {variant === 'statistics' ? pageTitle || copy.statisticsTitle : siteName}
        </h1>
        <p
          className={
            isCorridor ? 'swarm-public-header__subtitle' : 'text-sm text-gray-600 mb-0 mt-0.5'
          }
          data-testid="public-strapline"
        >
          {strapline}
        </p>
      </div>
    </div>
  );

  const actions = (
    <div className="flex flex-col sm:flex-row sm:flex-wrap sm:items-center gap-2 lg:gap-3">
      {variant === 'statistics' && (
        <button
          onClick={onBackToMain}
          className="btn btn-secondary text-sm px-4 py-2"
          data-testid="anonymous-back-button"
        >
          {copy.backToMain}
        </button>
      )}
      <button onClick={onSubmitReport} className="btn btn-primary text-sm px-4 py-2">
        {copy.submitReport}
      </button>
      {variant === 'welcome' && (
        <button
          onClick={onStatistics}
          className="btn btn-secondary text-sm px-4 py-2"
          data-testid="public-statistics-button"
        >
          {copy.reportStatistics}
        </button>
      )}
      <button onClick={onAuth} className="btn btn-secondary text-sm px-4 py-2">
        {copy.signInRegister}
      </button>
    </div>
  );

  if (isCorridor) {
    return (
      <header className="swarm-public-header mb-4" data-testid="public-welcome-header">
        <div className="swarm-public-header__inner">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-3 lg:gap-4">
            {brandBlock}
            {backLink && (
              <div className="swarm-public-header__back-link shrink-0 sm:ml-auto sm:text-right">
                {backLink}
              </div>
            )}
          </div>
          <p className="swarm-public-header__note">{copy.optionalRegistrationShort}</p>
        </div>
        <div className="swarm-public-header__centre-line" aria-hidden="true" />
        <div className="swarm-public-header__actions">{actions}</div>
      </header>
    );
  }

  return (
    <header className="bg-white shadow-md p-3 lg:p-4 mb-4" data-testid="public-welcome-header">
      <div className="flex flex-col lg:flex-row lg:justify-between lg:items-start gap-4">
        <div className="flex flex-col gap-2 flex-1 min-w-0">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-2 sm:gap-4">
            {brandBlock}
            {backLink && (
              <div className="swarm-public-header__back-link shrink-0 sm:ml-auto sm:text-right">
                {backLink}
              </div>
            )}
          </div>
          <p className="text-xs text-gray-500">{copy.optionalRegistrationShort}</p>
        </div>
        {actions}
      </div>
    </header>
  );
}
